// © 2013 - 2024 Tinder, Inc., ALL RIGHTS RESERVED

import React, { forwardRef, memo } from 'react';
import { cx } from '@linaria/core';

import styles from './styles';
import { SwitchProps } from './types';
import BooleanInput from '../BooleanInput';

const Switch: React.FunctionComponent<SwitchProps> = ({
  className,
  children,
  focused,
  disabled,
  readOnly,
  checked,
  accentColor,
}) => {
  return (
    <span
      data-focused={focused ? '' : undefined}
      data-disabled={disabled ? '' : undefined}
      data-readonly={readOnly ? '' : undefined}
      data-checked={checked ? '' : undefined}
      data-testid="toggle-switch"
      className={cx(className, styles.container)}
    >
      {children}
      <span
        data-testid="toggle-ui"
        style={
          accentColor
            ? ({ '--tui-switch-accent-color': accentColor } as React.CSSProperties)
            : undefined
        }
        className={styles.track}
      >
        <span className={styles.knob}></span>
        <span className={styles.overlay} />
      </span>
    </span>
  );
};

const MemoizedSwitch = memo(Switch);

const SwitchInput: React.ForwardRefRenderFunction<
  HTMLInputElement,
  React.ComponentProps<typeof BooleanInput>
> = (props, ref) => (
  <BooleanInput {...props} ref={ref} data-testid="toggle-switch-input" role="switch">
    {MemoizedSwitch}
  </BooleanInput>
);

export default forwardRef(SwitchInput);
